var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Controller } from 'stimulus';
import { useIntersection } from './use-intersection';
var IntersectionController = /** @class */ (function (_super) {
    __extends(IntersectionController, _super);
    function IntersectionController(context) {
        var _this = _super.call(this, context) || this;
        _this.isVisible = false;
        requestAnimationFrame(function () {
            var _a = useIntersection(_this, _this.options), observe = _a[0], unobserve = _a[1];
            Object.assign(_this, { observe: observe, unobserve: unobserve });
        });
        return _this;
    }
    return IntersectionController;
}(Controller));
export { IntersectionController };
//# sourceMappingURL=intersection-controller.js.map